<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1">
<div class="block-rw dedication-rw" id="dedication1">
<p class="ded-rw" id="p50"><span>Dedicated to<br/>
Sarah Younger,<br/>
for urging me to write about the Carlisles</span></p>
<p class="ded-rw" id="p3163"><span> </span></p>
<p class="ded-rw" id="p51"><span>And to my father,<br/>
who never once threatened<br/>
to send me away to school or to a convent<br/>
(although perhaps he wishes he had)</span></p>
<p class="ded-rw" id="p3164"><span> </span></p>
<p class="ded-rw" id="p52"><span>Special thanks to<br/>
Michele Bidelspach, Jordan Rubinstein, and Angelina Krahn<br/>
for all your help<br/>
in writing and releasing this book</span></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Dedication-01.vue?bba61502